import React, { useEffect } from 'react';
import GlassCard from './GlassCard';

/** width: px number. footer: buttons shown at the bottom. Scrolls if content is tall. */
export default function GlassModal({ open, onClose, title, width = 420, footer, children }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose?.();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="glass-overlay" onClick={onClose}>
      <GlassCard
        className="glass-modal"
        style={{ width: `min(${width}px, 94vw)` }}
        role="dialog" aria-modal="true" aria-label={title}
        onClick={(e) => e.stopPropagation()}
      >
        {title && <h3 className="glass-title">{title}</h3>}
        <div className="glass-modal__body">{children}</div>
        {footer && <div className="glass-modal__footer">{footer}</div>}
      </GlassCard>
    </div>
  );
}